import React from "react";
import styled from "styled-components";
import { ChildAppReactComponent } from "@mondora/microfrontends";
import Spinner from "../spinner";
import { useSelector } from "react-redux";
import "./style.css";

// Style and position the embedded iframe
const ChildApp = styled(ChildAppReactComponent)`
    border: 0;
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
`;

const BisChildApp = () => {

  const auth = useSelector(state => state.auth);
  const main = useSelector(state => state.main);

  const uuidToUse = main.myType === "STUDIO" ? main.accountantUuidSelected : main.companyUuidSelected;

  const launchData = {
    cookieConsents: document.cookie,
    item: {
      id: uuidToUse,
      classifier: main.myType,
      description: "ragioneSociale",
      taxId: "codiceFiscale",
      vatNumber: "partitaIva",
      ncsId: "base.ncsId",
      taxRegion: "base.identifier.taxRegion"
    },
    settings: {
      language: "profile.language"
    },
    user: {
      email: "loginAuth.id",
      firstName: "profile.firstName",
      id: "loginAuth.securityToken",
      lastName: "profile.lastName",
      ncsId: "profile.ncsId",
      token: auth.loginAuth.securityToken
    }
  };

  return <ChildApp
    url={"http://localhost:3001"}
    suppliedMethods={{
      // getNewAccessToken: () => refreshToken(auth)
    }}
    launchData={{
      ...launchData
    }}
    launchingPlaceholder={
      <Spinner />
    }
    onLaunched={() => {
      // The child app may have its own Elevio and UserVoice
      // launchers. When it does, we hide the ts-portale ones
    }}
    className={"dbx-childApp-root"}
  />;
};

export default BisChildApp;